import './MCPLayoutStyle.scss';

import { Visible } from '@tfecom-thermofisher/react-komodo-design';
import PropTypes from 'prop-types';
import React from 'react';

// import { Menu } from 'src/components';
import MenuComponent from '../Menu/MenuComponent';
import SearchHeaderContainer from '../SearchHeader';
import DetailViewComponent from './components/DetailView/DetailViewComponent';
import EmptyOverview from './components/EmptyOverview/EmptyOverview';
import OverviewComponent from './components/Overview/OverviewComponent';

const MCPLayoutComponent = ({
  isViewAllActive,
  selectedMenuItem,
  setSelectedMenuItem,
  menuGroups,
  overviewData,
  staticMenuItems,
  searchFormData,
  setSearchFormData,
  showAdvanceSearch,
  setShowAdvanceSearch,
  radioSelected,
  setRadioSelected,
  filterFormData,
  setFilterFormData,
}) => (
  <div className="mcp-content">
    <MenuComponent
      selectedMenuItem={selectedMenuItem}
      onSelectMenuItem={setSelectedMenuItem}
      menuGroups={menuGroups}
      isViewAllActive={isViewAllActive}
    />
    <div className="mcp-content__right">
      <Visible when={!overviewData.length}>
        <EmptyOverview
          staticMenuItems={staticMenuItems}
          menuGroups={menuGroups}
          selectedMenuItem={selectedMenuItem}
          onSelectMenuItem={setSelectedMenuItem}
          searchFormData={searchFormData}
          setSearchFormData={setSearchFormData}
          showAdvanceSearch={showAdvanceSearch}
          setShowAdvanceSearch={setShowAdvanceSearch}
          radioSelected={radioSelected}
          setRadioSelected={setRadioSelected}
          filterFormData={filterFormData}
          setFilterFormData={setFilterFormData}
        />
      </Visible>
      <Visible when={overviewData.length}>
        <SearchHeaderContainer
          menuGroups={menuGroups}
          selectedMenuItem={selectedMenuItem}
          onSelectMenuItem={setSelectedMenuItem}
          searchFormData={searchFormData}
          setSearchFormData={setSearchFormData}
          showAdvanceSearch={showAdvanceSearch}
          setShowAdvanceSearch={setShowAdvanceSearch}
          radioSelected={radioSelected}
          setRadioSelected={setRadioSelected}
          filterFormData={filterFormData}
          setFilterFormData={setFilterFormData}
        />
        <div className="mt-4">
          <Visible when={isViewAllActive}>
            <OverviewComponent
              {...{
                selectedMenuItem,
                data: overviewData,
                setSelectedMenuItem,
                isViewAllActive,
              }}
            />
          </Visible>
          <Visible when={!isViewAllActive}>
            <DetailViewComponent
              {...{
                selectedMenuItem,
                category: selectedMenuItem.category,
                subcategory: selectedMenuItem.subcategory,
                isViewAllActive,
              }}
            />
          </Visible>
        </div>
      </Visible>
    </div>
  </div>
);

MCPLayoutComponent.propTypes = {
  isViewAllActive: PropTypes.bool,
  selectedMenuItem: PropTypes.object,
  setSelectedMenuItem: PropTypes.func.isRequired,
  menuGroups: PropTypes.array.isRequired,
  overviewData: PropTypes.array.isRequired,
  staticMenuItems: PropTypes.array,
  searchFormData: PropTypes.object,
  setSearchFormData: PropTypes.func,
  showAdvanceSearch: PropTypes.bool,
  setShowAdvanceSearch: PropTypes.func,
  radioSelected: PropTypes.string,
  setRadioSelected: PropTypes.func,
  filterFormData: PropTypes.object,
  setFilterFormData: PropTypes.func,
};

export default MCPLayoutComponent;
